import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchCompetitors, type Competitor } from '../lib/api'
import { Card, SectionTitle, EmptyState, TierBadge } from '../components/ui'

export default function Competitors() {
  const [rows, setRows] = useState<Competitor[] | null>(null)
  const [error, setError] = useState<string | null>(null)
  useEffect(() => { fetchCompetitors().then((r) => setRows(r.competitors)).catch((e) => setError(String(e))) }, [])

  if (error) return <EmptyState title="Couldn't load competitors" hint={error} />
  if (!rows) return <p className="font-body text-sm text-ink/40">Loading…</p>

  return (
    <div>
      <SectionTitle note={`${rows.length} tracked`}>Competitor profiles</SectionTitle>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {rows.map((c) => (
          <Link key={c.id} to={`/competitors/${c.id}`}>
            <Card className="h-full p-5 transition-colors hover:border-oxblood/30 hover:bg-white">
              <div className="flex items-start justify-between">
                <h3 className="font-display text-xl text-oxblood">{c.name}</h3>
                <TierBadge tier={c.positioning_tier} />
              </div>
              <p className="mt-0.5 font-body text-xs text-ink/40">{c.location ?? '—'}</p>
              <div className="mt-4 grid grid-cols-3 gap-2 font-body">
                <Metric label="Products" value={c.product_count} />
                <Metric label="Variants" value={c.variant_count} />
                <Metric label="POA" value={c.variant_count ? `${Math.round((c.poa_count / c.variant_count) * 100)}%` : '—'} />
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  )
}

function Metric({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div>
      <p className="font-body text-lg text-oxblood tabular-nums">{value}</p>
      <p className="font-body text-[11px] uppercase tracking-wide text-ink/40">{label}</p>
    </div>
  )
}
